import React, { useState } from 'react';
import { supabase } from './supabaseClient'; // Assicurati che questo percorso sia corretto
import { useNavigate } from 'react-router-dom';
import './tailwind.css'; // Per gli stili di Tailwind CSS
import { FaBuilding, FaUserPlus, FaEnvelope, FaLock, FaSave, FaTimes } from 'react-icons/fa'; // Icone utili

export default function CreaAgenzia() {
  const navigate = useNavigate();

  // ⭐ Endpoint CORRETTO per la tua Edge Function su Supabase ⭐
  const CREATE_AGENCY_USER_ENDPOINT = 'https://zwgpmobugscpdcavajbu.supabase.co/functions/v1/create-agency-user';

  // Stati per i campi del form
  const [agencyName, setAgencyName] = useState('');
  const [userName, setUserName] = useState('');
  const [userSurname, setUserSurname] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPassword, setUserPassword] = useState('');

  // Stato per il caricamento e i messaggi di feedback
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isError, setIsError] = useState(false);

  // Funzione per la gestione del submit del form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedbackMessage('');
    setIsError(false);

    // Validazione semplice dei campi
    if (!agencyName || !userName || !userSurname || !userEmail || !userPassword) {
      setFeedbackMessage('Tutti i campi sono obbligatori.');
      setIsError(true);
      setLoading(false);
      return;
    }

    try {
      // ⭐ Chiamata all'Edge Function di Supabase con header Authorization rimosso ⭐
      const response = await fetch(CREATE_AGENCY_USER_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${(await supabase.auth.getSession()).data.session.access_token}`
        },
        body: JSON.stringify({
          agencyName,
          userName,
          userSurname,
          userEmail,
          userPassword,
        }),
      });

      // Gestione delle risposte HTTP non riuscite
      if (!response.ok) {
        const errorData = await response.json(); // Tenta di leggere l'errore come JSON
        throw new Error(errorData.error || `HTTP error! Status: ${response.status}`);
      }

      const data = await response.json(); // Se la risposta è OK, leggi il JSON

      setFeedbackMessage('Sede e utente creati con successo!');
      setIsError(false);
      // Resetta il form
      setAgencyName('');
      setUserName('');
      setUserSurname('');
      setUserEmail('');
      setUserPassword('');

      // Opzionale: reindirizza l'utente o mostra un messaggio di successo prolungato
      // navigate('/dashboard/broker/gestisci-agenzie'); 
    } catch (error) {
      console.error('Errore durante la creazione della Sede:', error.message);
      setFeedbackMessage(`Errore: ${error.message}`);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-2xl lg:max-w-3xl"> 
        <h1 className="text-2xl md:text-3xl font-bold uppercase mb-4 text-center text-mioblu">
          Crea Nuova Sede
        </h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Nome Agenzia */}
          <div>
            <label htmlFor="agencyName" className="block text-sm font-medium text-gray-700 mb-1">
              Nome Sede <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaBuilding className="text-gray-400" />
              </span>
              <input
                type="text"
                id="agencyName"
                value={agencyName}
                onChange={(e) => setAgencyName(e.target.value)}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                placeholder="Nome della Sede"
              />
            </div>
          </div>

          {/* Nome Utente */}
          <div>
            <label htmlFor="userName" className="block text-sm font-medium text-gray-700 mb-1">
              Nome Responsabile Sede <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaUserPlus className="text-gray-400" />
              </span>
              <input
                type="text"
                id="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                placeholder="Nome"
              />
            </div>
          </div>

          {/* Cognome Utente */}
          <div>
            <label htmlFor="userSurname" className="block text-sm font-medium text-gray-700 mb-1">
              Cognome Responsabile Sede <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaUserPlus className="text-gray-400" />
              </span>
              <input
                type="text"
                id="userSurname"
                value={userSurname}
                onChange={(e) => setUserSurname(e.target.value)}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                placeholder="Cognome"
              />
            </div>
          </div>

          {/* Email Utente */}
          <div>
            <label htmlFor="userEmail" className="block text-sm font-medium text-gray-700 mb-1">
              Email Utente <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaEnvelope className="text-gray-400" />
              </span>
              <input
                type="email"
                id="userEmail"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                placeholder="email@example.com"
              />
            </div>
          </div>

          {/* Password Temporanea */}
          <div>
            <label htmlFor="userPassword" className="block text-sm font-medium text-gray-700 mb-1">
              Password Temporanea <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaLock className="text-gray-400" />
              </span>
              <input
                type="password"
                id="userPassword"
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                placeholder="Password temporanea"
              />
            </div>
          </div>

          {/* Messaggio di feedback */}
          {feedbackMessage && (
            <div
              className={`p-3 rounded-md text-sm ${
                isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
              }`}
              role="alert"
            >
              {feedbackMessage}
            </div>
          )}

          {/* Pulsanti di azione */}
          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={() => navigate(-1)} // Torna indietro alla pagina precedente
              className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              <FaTimes className="mr-2 -ml-1 h-5 w-5" /> Annulla
            </button>
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-miorosso hover:bg-miorossohover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                'Creazione...'
              ) : (
                <>
                  <FaSave className="mr-2 -ml-1 h-5 w-5" /> Crea Sede
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}